import type { EditorView } from 'prosemirror-view';

import type { SizeAttrs, SizeSchema } from './size-mark';
import type { SizeMenuController } from './size-plugin.types';
import type { EditorButton, EditorMode } from '../../editor/types';
import { MarkService } from '../../helpers/mark-base';

export class SizeService<S extends SizeSchema> extends MarkService<S> {}

export class SizePlugin {
  public api: {
    sizeService: SizeService<SizeSchema>;
  };

  public buttons = {
    toggleSize: <EditorButton>{
      icon: 'format-size',
      tooltipText: 'wysiwyg.size',
      isActive: (...args) => this.menuController.isOpen(),
      run: (state, dispatch, origin) => {
        const select = (em: string): void => {
          if (em) {
            this.api.sizeService.add(state, dispatch, { em });
          } else {
            this.api.sizeService.remove(state, dispatch);
          }
          this.menuController.close();
          this.editorView.focus();
        };
        const getAttrs = () => {
          const attrs = <SizeAttrs | null>this.api.sizeService.getAttrsIfActive(state);
          return attrs ? attrs.em : null;
        };
        const { backdropClick$ } = this.menuController.open(origin.getBoundingClientRect(), {
          getActiveVal: getAttrs,
        });
        this.menuController.setSelectCallback(select);
        backdropClick$.subscribe(() => {
          this.menuController.close();
        });
      },
    },
  };

  private editorView: EditorView;

  constructor(protected menuController: SizeMenuController) {}

  public beforeInit(mode: EditorMode, schema: SizeSchema) {
    this.api = {
      sizeService: new SizeService(schema.marks.font_size),
    };
  }

  public afterInit(mode: EditorMode, editorView: EditorView) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins(schema: SizeSchema) {
    return [];
    // return [
    //   { priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings(schema)) },
    // ];
  }

  private getKeyBindings(schema: SizeSchema) {
    return {};
    // return {
    //   'Mod-B': toggleMark(schema.marks.strong),
    //   'Mod-b': toggleMark(schema.marks.strong),
    // };
  }
}
